export var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["COP"] = "COP";
    CurrencyEnum["PEN"] = "PEN";
    CurrencyEnum["CLP"] = "CLP";
    CurrencyEnum["UF"] = "UF";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["CRC"] = "CRC";
    CurrencyEnum["GTQ"] = "GTQ";
    CurrencyEnum["HNL"] = "HNL";
    CurrencyEnum["NIO"] = "NIO";
})(CurrencyEnum || (CurrencyEnum = {}));
